import { useState, useEffect, useRef } from "react";
import { Share } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function VibeCodeSection() {
  const [activeTab, setActiveTab] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const industries = [{
    title: "Restaurante",
    description: "Muestra tu menú, acepta reservas en línea, gestiona pedidos y haz crecer tu base de seguidores leales.",
    imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/restaurant_1x-3.png"
  }, {
    title: "Portafolio",
    description: "Presenta tu trabajo, comparte tu historia, atrae nuevas oportunidades y construye tu marca personal.",
    imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/portfolio_1x.jpg"
  }, {
    title: "Bienes Raíces",
    description: "Destaca tus propiedades, capta clientes potenciales de alta calidad, programa visitas y cierra más tratos.",
    imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/real-estate_1x.png"
  }, {
    title: "Fotografía",
    description: "Muestra tu visión única, cuenta historias a través de imágenes, conecta con clientes y construye un legado duradero.",
    imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/photography_1x.png"
  }, {
    title: "Agencia",
    description: "Demuestra tu experiencia, muestra casos de éxito de clientes y gana más negocios en línea.",
    imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/agency_1x.png"
  }, {
    title: "Blog",
    description: "Comparte tu voz, haz crecer tu audiencia, monetiza tu contenido y construye una comunidad próspera.",
    imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/blog_1x.png"
  }, {
    title: "Todas las industrias",
    description: "Sea cual sea tu industria, nuestro creador de sitios web con IA te ayuda a crear un sitio impresionante en minutos.",
    imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/all-industries_1x.png"
  }];
  return <section ref={sectionRef} className={`transition-all duration-700 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
    backgroundColor: "#FFFFFF",
    fontFamily: '"Evergrow Sans", Inter, sans-serif',
    color: "rgb(20, 21, 31)"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');`}</style>
      <div className="page-container" style={{
      margin: "152px auto"
    }}>
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-6 md:gap-4">
          <div className="flex flex-col" style={{
          maxWidth: "700px",
          gap: "12px"
        }}>
            <h3 style={{
            color: "rgb(20, 21, 31)",
            fontFamily: '"Evergrow Sans", Inter, sans-serif',
            fontSize: "40px",
            fontWeight: "700",
            lineHeight: "52px",
            textAlign: "left",
            letterSpacing: "-0.02em",
            margin: 0
          }} className="!font-medium">Creado para todo tipo de negocio.</h3>
            <p style={{
            color: "rgba(20, 21, 31, 0.8)",
            fontFamily: '"Evergrow Sans", Inter, sans-serif',
            fontSize: "20px",
            fontWeight: "400",
            lineHeight: "30px",
            margin: 0
          }}>
              Prueba nuestro creador de sitios web con IA gratuito para crear desde sitios informativos hasta tiendas de comercio electrónico en solo unos clics.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end" style={{
          gap: "12px",
          flexShrink: 0
        }}>
          </div>
        </div>

        <div className="flex flex-col md:flex-row" style={{
        marginTop: "48px",
        gap: "80px",
        alignItems: "flex-start"
      }}>
          <div className="relative flex-shrink-0 bg-contain bg-no-repeat bg-center rounded-lg shadow-md aspect-video" style={{
          width: "580px",
          maxWidth: "100%",
          height: "auto",
          backgroundImage: `url(${industries[activeTab].imageUrl})`,
          transition: "background-image 0.5s ease-in-out"
        }}>
          </div>

          <div className="flex flex-col" style={{
          flex: 1,
          minWidth: 0,
          gap: "0px"
        }}>
            {industries.map((industry, index) => {
            const isActive = activeTab === index;
            return <div key={industry.title} data-index={index} onClick={() => setActiveTab(index)} style={{
              display: "flex",
              cursor: "pointer",
              borderLeft: isActive ? "4px solid #000000" : "4px solid transparent",
              paddingLeft: "16px",
              paddingTop: index === 0 ? "0px" : "20px",
              paddingBottom: "20px",
              borderBottom: index < industries.length - 1 ? "none" : "none",
              transition: "border-color 0.2s"
            }}>
                  <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px"
              }}>
                    <span style={{
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "22px",
                  fontWeight: isActive ? "700" : "500",
                  lineHeight: "30px",
                  color: isActive ? "rgb(20, 21, 31)" : "rgba(20, 21, 31, 0.5)",
                  transition: "color 0.2s, font-weight 0.2s"
                }}>
                      {industry.title}
                    </span>
                    {isActive && <>
                        <p style={{
                    fontFamily: '"Evergrow Sans", Inter, sans-serif',
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "24px",
                    color: "rgba(20, 21, 31, 0.8)",
                    margin: 0
                  }}>
                          {industry.description}
                        </p>
                      </>}
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}